(function ($) {
  Drupal.behaviors.MPP = {
    attach: function (context, settings) {
      if ($('.mobile_mpp').length === 0) {
        return;
      }

      var cl = Drupal.cl;

      site.mpp.data = {
        category: page_data['catalog-mpp'].categories[0],
        categories: page_data['catalog-mpp'].categories
      };
      site.mpp.init();

      // Figure out which products are forumla based
      var forumulaProducts = [];

      $(site.mpp.data.category.products).each(function (i, product) {
        var undef;

        if ((product.skus !== undef) &&
          (product.skus[0] !== undef) &&
          (product.skus[0].STRENGTH !== undef) &&
          (product.skus[0].STRENGTH !== null)) {
          forumulaProducts.push(product.PRODUCT_ID);
        } else if ($('li.mpp-product.select_type_formula[data-productid="' + product.PRODUCT_ID + '"]').length > 0) {
          forumulaProducts.push(product.PRODUCT_ID);
        }
      });

      // Loop through the filter navigation object
      $('.mobile_mpp').each(function (i) {
        var thisFormatter = $(this);

        // For each product that should have a forumla picker, use the "select" formula button instead of the "Select size" (or shade) one
        // We just do this with css/js
        $('li.product[data-productid]', thisFormatter).each(function () {
          var $me = $(this),
            prod_id = $me.attr('data-productid');

          if ($.inArray(prod_id, forumulaProducts) > -1) {
            $me
              .find('.button-wrapper')
              .not('.formula')
              .hide()
              .end()
              .filter('.formula')
              .removeClass('hidden');
          }

          var skin_types = $me.find('.sku_select.skin_types option');

          if ($me.find('.not_shaded_sized:not(.hidden)').length === 1 && skin_types.length === 0) {
            $me.find('.button-wrapper.formula').addClass('hidden');
          } else if (skin_types.length > 0) {
            $me.find('.not_shaded_sized').addClass('hidden');
          }
        });

        // Filter navigation main
        thisFormatter.find('.mpp-filter > .mpp-wrapper > ul.menu > li > h2 > a').each(function (i) {
          $(this).on('click', function(e) {
            e.preventDefault();
            window.scrollTo(-100, 0); // first value for left offset, second value for top offset
            $('.mobile_mpp .mpp-filter').animate({
              left: '-100%',
              scrollTop: $('body').offset().top
            }, { duration: 200 });
            $('.product-list, .mpp_toggle_view').css({ 'opacity': '0.2' });
            $('.mobile_mpp .mpp-filter .depth-2 ul.menu').hide();
            $('.mobile_mpp .mpp-filter ul.menu .depth-1, .mobile_mpp .mpp-filter .depth-2').show();
            $('.mpp-filter > .mpp-wrapper .menu-container.depth-1').css({ 'margin-top': '-50px' });
            $('li.back h2.back').removeClass('hidden');
          });
        });

        // Filter navigation sub categories
        thisFormatter.find('.mpp-filter > .mpp-wrapper .depth-1 > ul.menu > li > h2 > a').each(function (i) {
        // Get "this" menu item text and use it to compare against .depth-2 filter div classes
          var menuItemText = $(this).text().replace(/\s/g, '-').toLowerCase();
          var depth1Ul = $(this).parent().parent().parent(),
            depth1li = depth1Ul.find('li.filter-depth-1-main'),
            depth1liH2Hide = depth1li.find('h2.hidden').parent().addClass('hideMe'),
            depth1liH2Show = depth1li.find('h2').not('.hidden').parent().addClass('showMe');

          $(this).on('click', function(e) {
            e.preventDefault();
            $('.mobile_mpp .mpp-filter').animate({
              left: '-200%',
              scrollTop: $('body').offset().top
            }, { duration: 200 });
            $('.mpp_toggle_view').css({ 'opacity': '0.2' });
            var thisParentDiv = $(this).parent().parent().parent().parent().parent(),
              thisParentDivHeight = $(thisParentDiv).height(),
              prodListMarginTop = '-' + thisParentDivHeight + 'px';

            $('.mpp_toggle_view').css({ 'margin-top': prodListMarginTop });
            $('.mobile_mpp .mpp-filter ul.menu .depth-1, .mobile_mpp .mpp-filter .depth-2').show();
            $('.mobile_mpp .mpp-filter .depth-2 ul.menu').show();
            $(this).parent().parent().siblings().children().not('.hidden').next().not(menuItemText).hide();
            // Get parent li position top and use it to dynamically adjust its children menu item top position
            var depth1ParentLiPosTop = $(this).parent().parent().position().top;

            depth1li.not('.hideMe').each(function () {
              if ($('.mpp-filter > .mpp-wrapper .menu-container.depth-2').hasClass(menuItemText)) {
                $('.mpp-filter > .mpp-wrapper .menu-container.depth-2').css({
                  'position': 'relative',
                  'top': '-' + (depth1ParentLiPosTop + 49) + 'px'
                });
              }
            });
          });
        });

        // Filters "APPLY" button
        thisFormatter.find('.mpp-filter > .mpp-wrapper .depth-2 > ul.menu > li > h2.back > a + span a').on('click', function(e) {
          e.preventDefault();
          // Get the main "Filter" text and replace it with the selected filter menu item text
          var filterMain = $('.mpp-filter > .mpp-wrapper > ul.menu > li.filter-main > h2 > a');
          var selectedFilter = $(this).parent().parent().parent().siblings().find('a.active span.filter-name');
          var selFilterText = [];
          var filterMainText;

          if ($(this).parent().parent().parent().siblings().hasClass('active')) {
            selectedFilter.each(function (i) {
              selFilterText.push($(this).text());
              if (selectedFilter.length > 1) {
                if (($(this).text().length * selectedFilter.length) > 25) {
                  filterMainText = filterMain.text('Filtered by ' + selFilterText[0].substr(0, 22) + '...');
                } else {
                  filterMainText = filterMain.text('Filtered by ' + selFilterText.join(', ').substr(0, 17) + '...');
                }
              } else {
                filterMainText = filterMain.text('Filtered by ' + selFilterText[i]);
              }
            });
          } else {
            filterMainText = filterMain.text('Filter');
          }

          window.scrollTo(-100, 0); // first value for left offset, second value for top offset
          $('.mobile_mpp .mpp-filter').animate({
            left: '0',
            scrollTop: $('body').offset().top
          }, { duration: 10 });
          $('.product-list').css({ 'opacity': '1' });
          $('.mpp_toggle_view').css({
            'opacity': '1',
            'margin-top': '0'
          });
          $('.mobile_mpp .mpp-filter ul.menu .depth-1, .mobile_mpp .mpp-filter .depth-2').hide();
        });

        // Back to "Filter" navigation main
        thisFormatter.find('.mpp-filter > .mpp-wrapper .depth-1 > ul.menu > li.back > h2.back > a').each(function (i) {
          $(this).on('click', function(e) {
            e.preventDefault();
            var filterMain = $('.mpp-filter > .mpp-wrapper > ul.menu > li.filter-main > h2 > a');
            var filterMainText = filterMain.text('Filter');

            window.scrollTo(-100, 0); // first value for left offset, second value for top offset
            $('.mobile_mpp .mpp-filter').animate({
              left: '0',
              scrollTop: $('body').offset().top
            }, { duration: 10 });
            $('.product-list, .mpp_toggle_view').css({ 'opacity': '1' });
            $('.mpp_toggle_view').css({ 'margin-top': '0' });
            $('.mobile_mpp .mpp-filter ul.menu .depth-1, .mobile_mpp .mpp-filter .depth-2').hide();
          });
        });

        // Back to filters navigation sub cats
        thisFormatter.find('.mpp-filter > .mpp-wrapper .depth-2 > ul.menu > li > h2.back > a').each(function (i) {
          $(this).on('click', function(e) {
            e.preventDefault();
            $('.mobile_mpp .mpp-filter').animate({
              left: '-100%'
            }, { duration: 200 });
            $('.mobile_mpp .mpp-filter .depth-2 ul.menu').hide();
            $('.product-list').css({ 'opacity': '0.2' });
            $('.mpp_toggle_view').css({
              'opacity': '0.2',
              'margin-top': '0'
            });
          });
        });

        // "Select Size" button on click show/hide caret
        thisFormatter.find('a.button.select_shade, a.button.js-select_kit_component').on('click', function () {
          var top = $(this).parents('.product').offset().top;

          setTimeout(function () {
            $('html, body').animate({
              scrollTop: top
            }, 500, function () {
              thisFormatter.find('.shaded .caret').show();
            });
          }, 100);
        });
      });

      // view toggle
      $('.mpp_toggle_view a').on('click', function(e) {
        e.preventDefault();

        var $prodList = $('ul.product-list');

        if ($prodList.hasClass('full_width')) {
          $prodList.removeClass('full_width');
          $(e.target).removeClass('toggle_on');
        } else {
          $prodList.addClass('full_width');
          $(e.target).addClass('toggle_on');
        }
      });

      // mpp filters
      $('.mpp_filter a').on('click', function(e) {
        e.preventDefault();

        var $filter = $('.mpp_filter'),
          $filters = $filter.find('.mpp_filters');

        if ($filters.is(':visible')) {
          $filters.slideUp(500, function () {
            $filter.removeClass('filter_down');
          });
        } else {
          $filters.slideDown(500, function () {
            $filter.addClass('filter_down');
          });
        }
      });
    }
  };
})(jQuery);
